import storage from './storage';

export function isCurrentUserLsp() {
  let storedRoles = storage.get('roles');
  return storedRoles && storedRoles.includes('ROLE_API_LSP');
}
